var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{ref:"vBtn",staticClass:"v-btn",attrs:{"disabled":_vm.disabled},on:{"click":function($event){$event.stopPropagation();return _vm.btn_click.apply(null, arguments)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }